import { AddUnits } from "shared/app/AddUnits";

export const AddUnitsView = () => <AddUnits />;
